import React, { useEffect } from 'react';
import { Typography } from '@shared/ui/typography/typography';
import { Button, Link } from '@vtbhome/juicyfront';
import { ListOfSteps, StepItem, ModalBody, ModalFooter, FilesList } from './modal-become-manager.styles';
import { ModalBecomeManagerProps } from './types';
import { NetworkStateNew } from '@shared/ui/network-state-new/network-state-new';
import { File } from '@shared/ui/file/file';
import { useFilesListSharedQuery } from '@entities/file/libs/hooks/use-files-list-shared-query/use-files-list-shared-query';
import { getQueryError } from '@shared/lib/utils/get-query-error/get-query-error';
import { DEFAULT_PARAMETERS } from './constants';
import { forceDownloadByUrl } from '@shared/lib/utils/force-download-by-url/force-download-by-url';
import { AllLink } from '@vtbhome/juicyfront/indexIcon';
import { DOCUMENTS_LIST } from '@entities/file/config/documents-constants';
import { Modal } from '@shared/ui/modal/modal';

export const ModalBecomeManager: React.FC<ModalBecomeManagerProps> = ({ isShow, onClose }) => {
    const [getFilesList, getFilesListResult] = useFilesListSharedQuery(DEFAULT_PARAMETERS);
    const isLoading =
        getFilesListResult.isLoading || getFilesListResult.isFetching || getFilesListResult.isUninitialized;
    const error = getQueryError(getFilesListResult);
    const filesList = getFilesListResult.data;
    const fileAgreement = filesList?.items.find((file) => file.code === `${DOCUMENTS_LIST.INTERACTION_AGREEMENT}`);

    useEffect(() => {
        getFilesList(DEFAULT_PARAMETERS);
    }, []);

    return (
        <Modal
            isShow={isShow}
            size='l'
            showLine={false}
            header={<Typography size='h5'>Стать менеджером</Typography>}
            footer={
                <ModalFooter>
                    <Button type='submit' buttonType='primary' size='l' onClick={onClose}>
                        Закрыть
                    </Button>
                </ModalFooter>
            }
            onClose={onClose}>
            <ModalBody>
                <NetworkStateNew
                    size='s'
                    isLoading={isLoading}
                    isError={Boolean(error)}
                    isInitialized={Boolean(filesList)}
                    isFiltered={false}
                    hasData={Boolean(filesList)}
                    errorProps={{
                        title: 'Ошибка загрузки файлов',
                        description: error?.message,
                    }}>
                    <ListOfSteps>
                        <StepItem>
                            <Typography size='body1_short'>Шаг 1 - скачать шаблон Заявки об акцепте.</Typography>
                        </StepItem>
                        <StepItem>
                            <Typography size='body1_short'>
                                Шаг 2 - направить этот шаблон вашему работодателю или организации.
                            </Typography>
                        </StepItem>
                        <StepItem>
                            <Typography size='body1_short'>
                                Шаг 3 - организация заполнит заявку, указав свои и ваши данные.
                            </Typography>
                        </StepItem>
                        <StepItem>
                            <Typography size='body1_short'>
                                Шаг 4 - организация подпишет заявку и отправит её нам в ООО «Т1 ИННОВАЦИИ» (ОГРН:
                                1187746683519, ИНН: 9718107268) с помощью системы «Контур.Диадок». Если у организации
                                нет уполномоченного лица на подписание заявки, необходимо также скачать, подписать и
                                направить шаблон Доверенности.
                            </Typography>
                        </StepItem>
                        <StepItem>
                            <Typography size='body1_short'>
                                Шаг 5 - после обработки вашей заявки мы пришлем подтверждение изменение роли.
                            </Typography>
                        </StepItem>
                    </ListOfSteps>
                    <FilesList>
                        {filesList?.items
                            ?.filter((file) => file.code !== `${DOCUMENTS_LIST.INTERACTION_AGREEMENT}`)
                            ?.map((file) => (
                                <File
                                    key={file?.id}
                                    isLoading={isLoading}
                                    uploadedFile={{
                                        url: file?.url,
                                        id: file?.id,
                                        name: file?.name,
                                        extension: file?.meta?.extension,
                                    }}
                                    onSave={() => forceDownloadByUrl(file?.url, file?.name)}
                                />
                            ))}
                    </FilesList>
                    {fileAgreement && (
                        <Link startAdornment={<AllLink />} href={fileAgreement.url}>
                            {fileAgreement.name}
                        </Link>
                    )}
                </NetworkStateNew>
            </ModalBody>
        </Modal>
    );
};
